module.exports = __webpack_public_path__ + "img/bg.da629d4f.png";